import { AgGridReact } from 'ag-grid-react';
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
export default function DataTable({
  height,
  toolPanel,
  columnDefs,
  rowsPerPage,
  onGridReady,
  onSelectionChanged,
  onColumnMoved,
  defaultPanel,
  onPaginationChanged,
  onCellValueChanged,
  singleClickEdit,
  modelType,
  rowData,
  selectionType,
  fromTemplate,
  pinnedBottomRowData
}) {
  return (
    <div
      className="ag-theme-quartz"
      style={{
        height: height,
        width: '100%',
        marginTop: fromTemplate ? 0 : 5
      }}
    >
      <AgGridReact
        rowStyle={{ backgroundColor: '#fff' }}
        headerHeight={26}
        rowHeight={26}
        defaultColDef={{
          sortable: true,
          resizable: true,
          hide: false,
          suppressMenu: true,
          wrapText: true,
          wrapHeaderText: true,
          autoHeaderHeight: true,
          cellStyle: (params) => ({
            background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
            border: 'none',
            fontSize: 12
          }),
        }}
        rowData={rowData}
        columnDefs={columnDefs}
        pagination
        rowModelType={modelType}
        cacheBlockSize={rowsPerPage}
        cacheOverflowSize={2}
        maxConcurrentDatasourceRequests={2}
        infiniteInitialRowCount={1}
        maxBlocksInCache={1}
        paginationPageSize={rowsPerPage}
        paginationPageSizeSelector={[10, 15, 25, 50, 100]}
        onGridReady={onGridReady}
        rowSelection={selectionType}
        onSelectionChanged={() => {
          if (onSelectionChanged) {
            onSelectionChanged();
          }
        }}
        onPaginationChanged={(event) => {
          if (onPaginationChanged) {
            onPaginationChanged(event);
          }
        }}
        onColumnMoved={onColumnMoved}
        onCellValueChanged={onCellValueChanged}
        singleClickEdit={singleClickEdit}
        pinnedBottomRowData={pinnedBottomRowData}
        sortingOrder={['desc', 'asc']}
        overlayNoRowsTemplate={
          '<span style="padding: 10px;font-weight: 600;font-size: 15px;">No Records Found</span>'
        }
        sideBar={{
          toolPanels: toolPanel,
          defaultToolPanel: defaultPanel
        }}
        suppressRowClickSelection
        suppressContextMenu
      />
    </div>
  )
} 